import styled from 'styled-components';

const ToolbarBackground = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  background-color: ${({ theme }) => theme.colors.gray2.hex};
`;

export { ToolbarBackground };
